import type { FC, ReactNode } from "react";

import * as styles from "./Page.styles";

interface Props {
  children: ReactNode;
}

const Page: FC<Props> = ({ children, ...rest }) => {
  return (
    <div css={styles.page} {...rest}>
      {children}
    </div>
  );
};

export { Page };
